<template>
  <section-page
    title="Partner Info"
    is-short
  >
    <div class="flex">
      <div>
        <p class="partner-text">This account is a partner account with {{partner.company_name}}.</p>
        <p class="partner-text">This means that your account is visible to {{partner.company_name}}. This allows them to help you with your account and business.</p>
      </div>
      <img class="partner-image" :src="partner.logo_url" alt="Easy Button Leads">
    </div>

    <p class="partner-text">They will have access to the following:</p>

    <ul v-if="hasAccess" class="partner-list">
      <li v-if="hasCampaignStats">Marketing Campaigns table similar to one found on the campaign stats page</li>
      <li v-if="hasLeadsDealsStats">Leads and Deals stats to one found on the leads and deals stats page</li>
      <li v-if="hasKPIStats">KPI table to one found on the KPI stats page</li>
      <li v-if="hasUserAccess">Access to your account via a third party user that you can manage on the Users modal</li>
    </ul>

    <p v-if="givesCallRailNumber" class="partner-text">{{partner.company_name}} also has given you a CallRail number to use. This number can be managed in the CallRail integration on our integrations page.</p>

    <p v-if="partner.login_url" class="partner-text">Visit <a :href="partner.login_url" target="_blank">{{partner.company_name}}</a> to manage your account</p>
  </section-page>
</template>

<script>
import {defineComponent} from 'vue'

export default defineComponent({
  name: "AccountPartnerInfo",
  computed: {
    partner() {
      return this.$store.getters.account.partner;
    },
    hasAccess() {
      return this.hasCampaignStats || this.hasLeadsDealsStats || this.hasKPIStats || this.hasUserAccess;
    },
    hasCampaignStats() {
      return this.partner.has_stats_campaign_feature;
    },
    hasLeadsDealsStats() {
      return this.partner.has_stats_leads_deals_feature;
    },
    hasKPIStats() {
      return this.partner.has_stats_kpi_feature;
    },
    hasUserAccess() {
      return this.partner.has_user_impersonate_feature;
    },
    givesCallRailNumber() {
      return this.partner.has_assign_callrail_numbers_feature;
    },
  },
})
</script>

<style scoped lang="scss">
.partner-text {
  margin-bottom: 10px;
  line-height: 1.3;
}

.partner-list {
  margin-bottom: 10px;
  padding-left: 2rem;
  list-style: disc;

  li {
    margin-bottom: 6px;
    line-height: 1.3;
  }
}

.partner-image {
  height: 3.75rem;
  margin-left: 2rem;
}
</style>
